

export const API_VERSION = "v2";

export const ICON_SET_BLUEPRINT = "bp";
export const ICON_SET_FONTAWESOME = "fa";

export const DESERIALIZE_TYPE_OBJECT = "OBJECT";
export const DESERIALIZE_TYPE_ARRAY_OBJECTS = "ARRAY_OBJECTS";
export const DESERIALIZE_TYPE_CUSTOM = "CUSTOM";
